// extracted by mini-css-extract-plugin
module.exports = {"startDate":"startDate__1ZEYt","text":"text__1-1VG"};